import { forwardRef } from 'react';

import type { ReactNode } from 'react';

import { CircularProgress } from '@mui/material';

import type { ButtonProps } from '@/libs/shared/ui';
import { Button } from '@/libs/shared/ui';

type Props = {
  isLoading?: boolean;
  loadingText?: string;
  children: ReactNode;
  disabled?: boolean;
} & Omit<ButtonProps, 'disabled' | 'children'>;

export const SubmitButton = forwardRef<HTMLButtonElement, Props>(
  ({ isLoading = false, loadingText, children, disabled = false, ...buttonProps }, ref) => {
    const isDisabled = disabled || isLoading;

    return (
      <Button
        {...buttonProps}
        ref={ref}
        disabled={isDisabled}
        startIcon={
          isLoading ? <CircularProgress size={16} color="inherit" /> : buttonProps.startIcon
        }
      >
        {isLoading && loadingText ? loadingText : children}
      </Button>
    );
  }
);
